// extracted by mini-css-extract-plugin
export default {"whiteContainer":"white-container_whiteContainer__IVc4p"};